import { Button, Checkbox, Divider, Form, message, Tag } from "antd";
import { apiGet, apiPost } from "app/services/apiServices";
import TextField from "app/shared/TextField";
import Typography from "app/shared/Typography";
import { useState } from "react";
import AppLogo from "static/images/Logo.svg";
import { ArrowRightOutlined, FileOutlined ,ArrowLeftOutlined} from "@ant-design/icons";
import { colorPicker } from "app/utils/color.helper";
import "../../AirlineCredentialFlow.scss";
import { useNavigate } from "react-router-dom";

type FieldType = {
  email?: string;
  password?: string;
};

export default function AirlineQuestion(props: any) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(1);
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
};
  return (
    <div className="AirlineStart">
      <span style={{ display: 'inline-flex', alignItems: 'center', marginBottom: 16, cursor: 'pointer' }} onClick={handleBack}>
        <ArrowLeftOutlined style={{ fontSize: '14px', marginRight: 2, color: '#0A8394', fontWeight: '400' }} />
        <Typography style={{ marginLeft: '3px', color: '#0A8394', fontFamily: 'Noto Sans', }}>
          Back
        </Typography>
      </span>
      <br />
      <Tag color="cyan">Airline Integration</Tag>
      <Typography variant="h5" style={{ marginTop: 12 }}>
        Ready with your airline credential?
      </Typography>

      <div className="QuestionareContainer" style={{ marginTop: 48 }}>
        <div
          className={`QuestionBox ${
            selectedQuestion === 1 ? "--selected" : ""
          }`}
          onClick={() => {
            setSelectedQuestion(1);
            navigate("/integrationnew");
          }}
        >
          <div className="LeftQuestion">
            <div className="IconBox">
              <FileOutlined style={{ color: colorPicker("primary.700") }} />
            </div>
            <div className="QuestionMeta">
              <Typography
                variant="h6"
                style={{ color: colorPicker("primary.800") }}
                weight={500}
              >
                I have airline portal credential
              </Typography>
              <Typography
                variant="xs"
                style={{ color: colorPicker("primary.700") }}
              >
                I have the necessary credentials to access the system and ensure
                compliance with all requirements.
              </Typography>
            </div>
          </div>
          <div className="RightQuestion">
            <ArrowRightOutlined style={{ color: colorPicker("primary.700") }} />
          </div>
        </div>
        <div
          className={`QuestionBox ${
            selectedQuestion === 2 ? "--selected" : ""
          }`}
          onClick={() => {
            setSelectedQuestion(2);
            navigate("/credential/airline/question/invite");
          }}
        >
          <div className="LeftQuestion">
            <div className="IconBox">
              <FileOutlined style={{ color: colorPicker("primary.700") }} />
            </div>
            <div className="QuestionMeta">
              <Typography
                variant="h6"
                style={{
                  color: colorPicker(
                    selectedQuestion === 2 ? "primary.800" : "neutral.800"
                  ),
                }}
                weight={500}
              >
                I don't have airline portal credential
              </Typography>
              <Typography
                variant="xs"
                style={{
                  color: colorPicker(
                    selectedQuestion === 2 ? "primary.800" : "neutral.700"
                  ),
                }}
              >
                I have the necessary credentials to access the system and ensure
                compliance with all requirements.
              </Typography>
            </div>
          </div>
          <div className="RightQuestion">
            <ArrowRightOutlined style={{ color: colorPicker("primary.700") }} />
          </div>
        </div>
      </div>
    </div>
  );
}
